export const calculateOverallAverageCustomerRating = (feedbackList) => {
    let totalSum = 0;
    let totalCount = 0;
  
    feedbackList.forEach(feedback => {
      if (feedback.ratings && feedback.ratings.length) {
        const sum = feedback.ratings.reduce((acc, rating) => acc + rating, 0);
        totalSum += sum;
        totalCount += feedback.ratings.length;
      }
    });
  
    return totalCount > 0 ? (totalSum / totalCount) : 0;
  };